import { render, staticRenderFns } from "./TableDiagnosticImageCategory.vue?vue&type=template&id=6a891a5c"
import script from "./TableDiagnosticImageCategory.vue?vue&type=script&lang=js"
export * from "./TableDiagnosticImageCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports